import script from "./AdminPropertiesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPropertiesPage.vue?vue&type=script&setup=true&lang=js"

import "./AdminPropertiesPage.vue?vue&type=style&index=0&id=bb219510&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb219510"]])

export default __exports__